import React from "react";
import { Observer } from "mobx-react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Label } from "@components/typography/Label";
import { Checkbox } from "@common/formx";
import { HighHolidayInput } from "@bonliva-crm/graphql";

type Props = {
  formStore: any;
  name: string;
  disabled: boolean;
};

export const ContractHolidays = ({
  formStore,
  name = "highHolidays",
  disabled = false
}: Props) => {
  // const editorStore = useContext(CustomerContractEditorStoreContext);
  const highHolidaysList: HighHolidayInput[] = formStore.getValue(name);
  const handleChangeHoliday = (e, checked, i) => {
    if (checked) {
      formStore.setValue(`${name}.${i}.isGreatHoliday`, false);
    } else {
      formStore.setValue(`${name}.${i}.isGreatHoliday`, null);
    }
  };
  const handleChangeHighHoliday = (e, checked, i) => {
    if (!highHolidaysList[i].isGreatHoliday) {
      formStore.setValue(`${name}.${i}.isGreatHoliday`, true);
    } else {
      formStore.setValue(`${name}.${i}.isGreatHoliday`, null);
    }
  };

  return (
    <Observer>
      {() => (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 100 }}>{locale.GreatHoliday}</TableCell>
              <TableCell style={{ width: 100 }}>{locale.NormalHoliday2}</TableCell>
              <TableCell>{locale.Detail}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {highHolidaysList?.map((hh, i) => {
              return (
                <TableRow key={hh._id ?? i}>
                  <TableCell>
                    <Checkbox
                      key={`normal${i}`}
                      name={`${name}.${i}.isGreatHoliday`}
                      CheckboxProps={{
                        checked: !!highHolidaysList[i].isGreatHoliday,
                        onChange: (e, checked) => handleChangeHighHoliday(e, checked, i),
                        disabled
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Checkbox
                      key={`high${i}`}
                      name={`${name}.${i}.isGreatHoliday`}
                      CheckboxProps={{
                        checked:
                          !formStore.getValue(name)[i].isGreatHoliday &&
                          formStore.getValue(name)[i].isGreatHoliday !== null,
                        disabled,
                        onChange: (e, checked) => handleChangeHoliday(e, checked, i)
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Label>
                      {locale.highHolidaysList[hh.option.name] ?? hh.option.name}
                    </Label>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </Observer>
  );
};
